import Marionette from "backbone.marionette";

import modelUtil from "../../../models/util";
import cTmpl from "../../../templates/components";
import templ from "../../../templates/review";

const SimilarPositionView = Marionette.View.extend({
    template: cTmpl.JobCard,
    className: "job-card",
    serializeData() {
        const data = this.model.toJSON();

        const stype = modelUtil.SCHEDULE_TYPE_MAP[data.schedule_type];
        data.schedule_type_text = stype || "";

        if (data.schedule_start && data.schedule_start.match(/\d(am|pm)/i)) {
            data.schedule_start = `${data.schedule_start.toLowerCase()} start time`;
        }

        data.link += "?related=1";

        return data;
    },
});

export default Marionette.CompositeView.extend({
    template: templ.Similar,
    childView: SimilarPositionView,
    childViewContainer: ".job-card-list",

    ITEMS_TO_LOAD: 3,

    events: {
        "click @ui.loadMoreBtn": "loadMore",
    },

    ui: {
        container: ".job-card-list-container",
        list: ".job-card-list",
        loadMoreBtn: ".job-card-list-load-more",
    },

    initialize() {
        this.shown = this.ITEMS_TO_LOAD;
        this.listHeight = null;
    },

    filter(child, index) {
        return index < this.shown;
    },

    loadMore() {
        this.shown += this.ITEMS_TO_LOAD;
        this.render();
    },

    onRender() {
        if (this.shown < this.collection.length) {
            this.ui.loadMoreBtn.removeClass("hidden");
        } else {
            this.ui.loadMoreBtn.addClass("hidden");
        }

        if (this.listHeight) {
            // Entire DOM is replaced every time render happens...
            this.ui.container.height(this.listHeight);

            this.listHeight = this.ui.list.outerHeight();
            this.ui.container.animate({ height: `${this.listHeight}px` }, "fast");
        }
    },

    onAttach() {
        this.listHeight = this.ui.list.outerHeight();

        this.ui.container.height(this.listHeight);
    },
});
